export default "__VITE_ASSET__076d3dc5__"